import React, { useState, useContext } from 'react';
import './home.css';
import { UserContext } from '../context/UserContext';

export default function B2B() {
  const { user } = useContext(UserContext);
  const [openFaq, setOpenFaq] = useState(null);
  const faqs = [
    {
      q: 'Wie viele Beiträge sollten wir veröffentlichen?',
      a: 'Ein guter Richtwert sind zwei bis drei Beiträge pro Woche. In anderen Fällen können auch zwei Beiträge pro Tag Sinnvoll sein. Die genaue Frequenz hängt von Ihren Zielen, Ihrer Zielgruppe und Ihren Kapazitäten ab – wir beraten Sie gerne dazu.'
    },
    {
      q: 'Müssen wir eigenes Bild- oder Videomaterial liefern?',
      a: 'Nicht zwingend. Jedoch je mehr Material vorhanden ist, desto besser. Wenn Sie nichts oder nur wenig haben, können wir aber auch komplett eigene Inhalte für Sie produzieren.'
    },
    {
      q: 'Können wir unsere Social-Media-Aktivitäten komplett an Sie auslagern?',
      a: 'Absolut, Ja. Sie können einzelne Teilbereiche oder Ihren gesamten digitalen Auftritt über uns laufen lassen – von der Planung über die Umsetzung bis hin zur Auswertung.'
    },
    {
      q: 'Erhalten wir einen Überblick, welche Inhalte wann online gehen?',
      a: 'Selbstverständlich. Wir arbeiten mit Redaktionsplänen, die vorab erstellt und zentral zugänglich sind. So behalten Sie jederzeit den Überblick und können eigene Ideen einbringen.'
    },
    {
      q: 'Betreuen Sie auch Creator und Streamer direkt?',
      a: 'Ja. Ein großer Teil unserer Arbeit richtet sich direkt an Content-Creator und Streamer. Viele Erfahrungen, Tools und Workflows aus diesem Bereich lassen sich aber hervorragend auf Organisationen übertragen – genau davon profitieren Sie im B2B-Bereich.'
    },
    {
      q: 'Sind auch Kooperationen mit Influencern möglich?',
      a: 'Definitiv. Dank unseres Creator-Netzwerks können wir passende Kooperationen vermitteln. Sowohl innerhalb unseres Netzwerks als auch mit externen Influencern. Dadurch sind auch Kooperationen mit anderen Influencern jeglicher größe und Reichweite möglich.'
    }
  ];
  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Speziell für Firmen und Vereine (B2B)</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>
          Lösungen für Organisationen, die mit Creator-Kompetenz, Events und moderner Web-Technik
          nachhaltige Sichtbarkeit und Community-Wirkung erzielen wollen.
        </p>
      </section>
      {/* Content */}
      <section
        style={{
          width: '100%',
          maxWidth: 1100,
          margin: '0 auto',
          padding: '0 16px 40px 16px',
          color: '#fff',
        }}
      >
        {/* Einleitender Text */}
        <div
          style={{
            maxWidth: 900,
            margin: '0 auto 32px',
            padding: '0 4px',
            fontSize: 16,
            lineHeight: 1.55,
            color: '#D6D9E0'
          }}
          aria-label="Einleitung"
        >
          <p style={{ margin: '0 0 12px' }}>
            Die digitale Öffentlichkeit hat sich in den letzten Jahren rasant verändert.
            Ob Verein, kleines Unternehmen, lokale Initiative oder öffentliche Einrichtung – Menschen informieren
            sich heute anders: schneller, direkter, visueller.
          </p>
          <p style={{ margin: '0 0 0' }}>
            Wir unterstützen Sie dabei, genau dort sichtbar zu werden, wo Ihre Zielgruppe bereits aktiv ist. Mit Strategien
            aus dem Social-Media-Marketing, Know-how aus der Creator-Welt und moderner Web-Technologie schaffen wir
            echte Wirkung – nahbar, professionell und nachhaltig.
          </p>
        </div>
        {/* Warum digitale Sichtbarkeit wichtig ist */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Warum digitale Sichtbarkeit wichtig ist</h2>
          <div style={{ color: '#D4D8DF', fontSize: 15, lineHeight: 1.6 }}>
            <p style={{ margin: '6px 0 14px' }}>
              Soziale Medien sind längst nicht mehr „nur ein Trend“. Sie sind ein Kommunikationsraum, in dem Meinungen
              entstehen, Sympathie aufgebaut wird und Marken Vertrauen gewinnen.
            </p>
            <p style={{ margin: '0 0 10px', fontWeight: 600, color: '#E2E5EA' }}>Für Organisationen bedeutet das:</p>
            <div style={{ display: 'grid', gap: 2, marginBottom: 14 }}>
              <div style={{ padding: '2px 0' }}>
                <span style={{ fontWeight: 700 }}>direkter Kontakt</span> zu Mitgliedern, Kunden oder Bürgern
              </div>
              <div style={{ padding: '2px 0' }}>
                <span style={{ fontWeight: 700 }}>authentischer Einblick</span> in Projekte, Werte und Leistungen
              </div>
              <div style={{ padding: '2px 0' }}>
                <span style={{ fontWeight: 700 }}>Stärkung der eigenen Marke</span> – regional wie digital
              </div>
              <div style={{ padding: '2px 0' }}>
                <span style={{ fontWeight: 700 }}>bessere Auffindbarkeit</span> in Suchmaschinen
              </div>
              <div style={{ padding: '2px 0' }}>
                <span style={{ fontWeight: 700 }}>mehr Aufmerksamkeit</span> für Aktionen, Veranstaltungen und Angebote
              </div>
            </div>
            <p style={{ margin: 0 }}>
              Selbst kleine Vereine oder lokale Unternehmen können heute eine starke digitale Präsenz aufbauen, ohne riesige Budgets.
              Entscheidend sind Klarheit, Strategie und regelmäßige Interaktion – genau dabei unterstützen wir Sie.
            </p>
          </div>
        </div>
        {/* Leistungen für Organisationen (mit einklappbaren Kacheln) */}
        <LeistungenCard />
        {/* Digitale Technik & Web-Lösungen */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Digitale Technik &amp; Web-Lösungen</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Neben Social Media unterstützen wir Sie mit moderner Web-Technik. Besonders sinnvoll für Vereine, Museen, Schulen, Einrichtungen oder Kommunalprojekte.
          </p>
          <p style={{ margin: '0 0 14px', color: '#D4D8DF' }}>
            Viele unserer Tools stammen ursprünglich aus der Creator-Szene – mit starkem Fokus auf technischer Innovation,
            Automatisierung und präzisem Zielgruppenverständnis. Durch diesen Ansatz wirkt Ihre digitale Präsenz oft frischer,
            moderner und effizienter als klassische Agenturkonzepte.
          </p>
          <p style={{ marginBottom: 8, color: '#D4D8DF' }}>
            Diese Werkzeuge setzen wir auch für Organisationen ein, zum Beispiel für:
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10, justifyContent: 'center' }}>
            {[
              'Landingpages & Aktionsseiten',
              'QR-Code-Projekte',
              'Online-Formulare',
              'Teilnehmer-Management',
              'Umfragen & Feedback',
              'Ticketing-Integrationen',
              'Community-Bereiche',
              'Automationen & Workflows',
            ].map((t, i) => (
              <span
                key={i}
                style={{
                  fontSize: 12,
                  lineHeight: '20px',
                  padding: '4px 10px',
                  borderRadius: 999,
                  border: '1px solid rgba(255,255,255,0.15)',
                  background: 'rgba(255,255,255,0.03)',
                  color: '#D4D8DF',
                  textAlign: 'center'
                }}
              >
                {t}
              </span>
            ))}
          </div>
          <p style={{ marginTop: 4, color: '#D4D8DF' }}>
            So verbinden wir Ihre bestehenden Prozesse mit moderner Web-Technik und schaffen reibungslose
            Abläufe für Teams, Mitglieder und Teilnehmende.
          </p>
        </div>
        {/* Prozess */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Unser Prozess – klar, einfach, strukturiert</h2>
          <p className="highlight-desc" style={{ margin: '0 0 16px', lineHeight: 1.6 }}>
            Wir arbeiten transparent und in klaren Schritten – damit Sie jederzeit wissen, wo das Projekt steht
            und welche nächsten Maßnahmen anstehen.
          </p>
          <ol style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 12, gridTemplateColumns: 'repeat(3, 1fr)' }}>
            {[
              'Analyse & Kennenlernen',
              'Ziele definieren',
              'Strategie & Maßnahmen entwickeln',
              'Content planen & produzieren',
              'Veröffentlichung & Community-Management',
              'Reporting & Optimierung'
            ].map((step, i) => (
              <li
                key={i}
                style={{
                  display: 'flex',
                  gap: 12,
                  alignItems: 'center',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  borderRadius: 10,
                  padding: '10px 14px',
                  minHeight: 90
                }}
              >
                <span
                  style={{
                    flexShrink: 0,
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #32CD89 0%, #1B774C 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    fontSize: 14,
                    color: '#fff',
                    boxShadow: '0 0 0 2px rgba(50,205,137,0.4)'
                  }}
                  aria-label={`Schritt ${i + 1}`}
                >
                  {i + 1}
                </span>
                <span style={{ color: '#D4D8DF', fontSize: 14, lineHeight: 1.5, flex: 1, textAlign: 'center' }}>{step}</span>
              </li>
            ))}
          </ol>
        </div>
        {/* FAQ */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Häufige Fragen (FAQ)</h2>
          <div style={{ display: 'grid', gap: 10, width: '100%' }}>
            {faqs.map((item, i) => {
              const open = openFaq === i;
              const panelId = `faq-panel-${i}`;
              return (
                <div
                  key={i}
                  style={{
                    border: '1px solid rgba(255,255,255,0.12)',
                    borderRadius: 10,
                    background: 'rgba(255,255,255,0.03)',
                    width: '100%'
                  }}
                >
                  <button
                    onClick={() => setOpenFaq(open ? null : i)}
                    aria-expanded={open}
                    aria-controls={panelId}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      background: 'transparent',
                      color: '#E2E5EA',
                      fontWeight: 600,
                      padding: '12px 14px',
                      paddingRight: 38,
                      border: 'none',
                      textAlign: 'center',
                      cursor: 'pointer'
                    }}
                  >
                    <span style={{ display: 'block', width: '100%', textAlign: 'center' }}>{item.q}</span>
                    <span aria-hidden="true" style={{ opacity: 0.85, position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)' }}>
                      {open ? '−' : '+'}
                    </span>
                  </button>
                  {open && (
                    <div id={panelId} style={{ padding: '0 14px 12px 14px', color: '#D4D8DF', lineHeight: 1.6 }}>
                      <p style={{ margin: 0 }}>{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        {/* Verweise & Kontakt */}
        <div className="highlight-card" style={{ padding: 24 }}>
          <h2 className="highlight-title">Mehr erfahren &amp; Kontakt</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Sie möchten prüfen, welche Maßnahmen für Ihre Organisation sinnvoll sind? Wir nehmen uns gerne Zeit
            für ein unverbindliches Erstgespräch und zeigen Ihnen, wie wir Sie unterstützen können.
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <a
              className="hero-btn-secondary"
              href="/angebote"
              style={{ padding: '12px 18px', textDecoration: 'none' }}
            >
              Überblick unserer Angebote
            </a>
            <a
              className="hero-btn-primary"
              href="/kontakt"
              style={{ padding: '12px 18px', textDecoration: 'none' }}
            >
              Kontakt aufnehmen
            </a>
          </div>
          <div style={{ marginTop: 16 }}>
            <a href="#top" style={{ color: '#32CD89' }}>
              Nach oben
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

function LeistungenCard() {
  const sections = [
    {
      key: 'strategie',
      title: 'Beratung & Strategie',
      bodyLines: {
        intro: 'Wir entwickeln gemeinsam mit Ihnen eine klare digitale Ausrichtung – maßgeschneidert für Ihre Ziele.',
        heading: 'Dazu gehören u. a.:',
        items: [
          'Analyse Ihres aktuellen Online-Auftritts',
          'Definition von Zielgruppen & Kommunikationszielen',
          'Auswahl der passenden Plattformen',
          'Entwicklung einer realistischen, nachhaltigen Social-Media-Strategie',
          'Empfehlungen für Inhalte, Kampagnen und Formate'
        ],
        outro: 'Damit Ihr Verein, Ihr Unternehmen oder Ihre Einrichtung online professionell auftritt – ohne sich zu verbiegen.'
      }
    },
    {
      key: 'operative',
      title: 'Operative Betreuung Ihrer Kanäle',
      bodyLines: {
        intro: 'Wenn Sie keine Zeit haben, Social Media regelmäßig zu pflegen, übernehmen wir das für Sie:',
        heading: null,
        items: [
          'Erstellung & Planung von Beiträgen',
          'Moderation von Kommentaren',
          'Community-Management',
          'Redaktionspläne & klare Abläufe',
          'Aktualität & Trendbeobachtung'
        ],
        outro: 'So stellen Sie sicher, dass Ihre Kanäle aktiv bleiben – auch wenn im Alltag wenig Zeit bleibt.'
      }
    },
    {
      key: 'content',
      title: 'Content-Produktion & Schnitt',
      bodyLines: {
        intro: 'Professionelle Inhalte wirken. Wir unterstützen Sie dabei, hochwertigen Content zu erstellen – von Foto bis Video:',
        heading: null,
        items: [
          'Event-Begleitung & Dokumentation',
          'Video-Clips, Kurzvideos, Reels',
          'Interviews, Statements & Image-Material',
          'Livestream-Technik (mobil & stationär)',
          'Postproduktion: Schnitt, Ton, Farben, Einblendungen'
        ],
        outro: 'Ideal für regelmäßige Content-Formate, Kampagnen und Veranstaltungen.'
      }
    },
    {
      key: 'marketing',
      title: 'Marketing, Ads & Performance-Analyse',
      bodyLines: {
        intro: 'Wir zeigen, was funktioniert – und was nicht. Dazu gehört:',
        heading: null,
        items: [
          'Performance-Check Ihrer bisherigen Aktivitäten',
          'Auswertung von Reichweite, Interaktionen & Wachstum',
          'zielgerichtete Empfehlungen für Verbesserungen',
          'Einrichtung & Optimierung von Werbeanzeigen (Meta/Google)',
          'monatliche Reports und klare Handlungsempfehlungen'
        ],
        outro: 'Damit Sie Entscheidungen auf Basis von echten Daten treffen können.'
      }
    },
    {
      key: 'events',
      title: 'Social-Media-Events & Kampagnen',
      bodyLines: {
        intro: 'Ob Tag der offenen Tür, Vereinsfest oder Online-Event – wir helfen Ihnen dabei, Ihr Event digital erlebbar zu machen:',
        heading: null,
        items: [
          'Erstellung eines Social-Media-Eventplans',
          'Content vor, während & nach dem Event',
          'Highlight-Clips & Livestream-Begleitung',
          'Community-Aktivierungen, Challenges, Aktionen'
        ],
        outro: 'Events bieten enormes Potenzial für Aufmerksamkeit – wir nutzen es gemeinsam mit Ihnen.'
      }
    },
    {
      key: 'gewinnspiele',
      title: 'Gewinnspiele, Give-Aways & Verlosungen',
      bodyLines: {
        intro: 'Sie möchten ein Gewinnspiel sicher und professionell umsetzen?\nWir übernehmen:',
        heading: null,
        items: [
          'Konzeption',
          'Gestaltung',
          'Abläufe',
          'Teilnahmebedingungen (ohne Rechtsberatung)',
          'Plattform-Richtlinien & DSGVO-Konformität'
        ],
        outro: 'So vermeiden Sie Risiken – und nutzen das volle Potenzial von Community-Aktionen.'
      }
    }
  ];
  const TILE_HEIGHT = 380; // feste Höhe der Kacheln, alle Inhalte sind dauerhaft sichtbar
  return (
    <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
      <h2 className="highlight-title" style={{ marginBottom: 12 }}>Unsere Leistungen für Organisationen</h2>
      <p style={{ color: '#D4D8DF', margin: '0 0 18px', fontSize: 15, lineHeight: 1.5 }}>
        Wir unterstützen Vereine, KMUs, Mittelstand und öffentliche Einrichtungen dabei, professionell und nahbar in der digitalen Öffentlichkeit aufzutreten – von der Strategie bis zur Umsetzung im Alltag.
      </p>
      <div style={{
        display: 'grid',
        gap: 16,
        gridTemplateColumns: 'repeat(3, 1fr)',
        alignItems: 'stretch'
      }}>
        {sections.map(sec => (
          <div
            key={sec.key}
            style={{
              border: '1px solid rgba(255,255,255,0.15)',
              background: 'rgba(50,205,137,0.12)',
              borderRadius: 14,
              padding: '14px 16px',
              boxShadow: '0 0 0 1px rgba(50,205,137,0.35), 0 4px 14px -2px rgba(0,0,0,0.4)',
              display: 'flex',
              flexDirection: 'column',
              height: TILE_HEIGHT,
              overflow: 'hidden'
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 10 }}>{sec.title}</div>
            <div style={{ fontSize: 13, lineHeight: 1.55, color: '#D4D8DF', overflow: 'hidden' }}>
              {sec.body && sec.body}
              {sec.bodyLines && (
                <div>
                  <p style={{ margin: '0 0 8px' }}>{sec.bodyLines.intro}</p>
                  {sec.bodyLines.heading && (
                    <p style={{ margin: '0 0 6px', fontWeight: 600, color: '#E2E5EA' }}>{sec.bodyLines.heading}</p>
                  )}
                  <div style={{ display: 'grid', gap: 4, marginBottom: 10 }}>
                    {sec.bodyLines.items.map((it, i) => (
                      <div key={i} style={{ padding: '2px 0' }}>{it}</div>
                    ))}
                  </div>
                  <p style={{ margin: 0 }}>{sec.bodyLines.outro}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
